<template>
    <div class="flex">
        <div class="wrap-input bi-com bi-cb cbx-ctrl">
            <img
                class="bi-cb-icon"
                src="@/assets/icon/check-box-active.svg"
                alt=""
                v-show="check"
                @click="toggleCheckBox()" />
            <img
                class="bi-cb-icon"
                src="@/assets/icon/check-box-inactive.svg"
                alt=""
                v-show="!check"
                @click="toggleCheckBox()" />
        </div>
        <div class="bi-cb-lbl pl-2 text-22 text-a-gray-666666" v-html="text"></div>
    </div>
</template>
<script>
export default {
    name: "Checkbox",
    props: {
        check: { type: Boolean }, // v-model:check
        text: { type: String, required: true },
    },
    methods: {
        toggleCheckBox: function () {
            let value = !this.check;
            this.$emit('update:check', value);
        }
    },
}
</script>
<style lang="scss" scoped>
    .cbx-ctrl{
        display: flex;

        .bi-cb-icon-wrapper{
            width: 27px;
            height: 29px;
        }

        .bi-cb-lbl{
            margin-left: 10px;
        }
    }
</style>
